<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="p1"><h2 class="partNumber">PART ONE</h2><h2 class="partTitle">T<span class="smallCaps"><span>HE</span></span> T<span class="smallCaps"><span>HREADS OF</span></span> H<span class="smallCaps"><span>ERESY</span></span></h2></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780743273251_p1.vue?65021dc9